var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"page-header clear-filter",attrs:{"filter-color":"greenTogreen"}},[_c('div',{staticClass:"container d-flex flex-column mt-4 col-10"},[_c('CluberForm',{attrs:{"prefix":"CTRL"}})],1)]),_c('support-entities-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }